import { useId, useMemo } from 'react';
import { useTheme } from './useTheme';
import { scopeSvg } from './svg';
import type { ArtworkRole } from './types';
export function ThemeArtwork({ role, className }: { role: ArtworkRole; className: string }) {
  const art = useTheme().seasonPackage.artwork[role];
  const id = useId().replace(/[^a-zA-Z0-9_-]/g, '');
  const svg = art.source.kind === 'inline' ? art.source.svg : '';
  const markup = useMemo(() => scopeSvg(svg, `art-${id}`), [svg, id]);
  return art.source.kind === 'image' ? (
    <img
      src={art.source.src}
      width={art.width}
      height={art.height}
      className={className}
      alt=""
      aria-hidden="true"
    />
  ) : (
    <span className={className} aria-hidden="true" dangerouslySetInnerHTML={{ __html: markup }} />
  );
}
